import { Outlet, useLocation, Navigate } from "react-router";
import { useAuth } from "./AuthContext";

const ProtectedRoute = () => {
  const { user, loading, application, profile } = useAuth(); // Add loading state
  const location = useLocation();

  // If still loading user or profile, show a loading indicator
  if (loading || (!profile && user)) {
    return <p>Loading...</p>; // Or replace with a better UI spinner
  }
  // If user is not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is not logged in, redirect to login
  if (application?.submitted) {
    return <Navigate to="/thank-you" state={{ from: location }} replace />;
  }

  // Get the current date and time
  const now = new Date();

  // Define the scholarship period
  const scholarshipStart = new Date(now.getFullYear(), 0, 1); // January 1 at 12:00 AM
  const scholarshipEnd = new Date(now.getFullYear(), 3, 1, 23, 59, 59); // April 1 at 11:59 PM

  // Check if the user has an extension
  const extensionDate = application?.extensionDate
    ? new Date(application.extensionDate)
    : null;

  // Determine if the application is open
  const isApplicationOpen =
    (now >= scholarshipStart && now <= scholarshipEnd) || // Within the scholarship period
    (extensionDate &&
      now <=
        new Date(
          extensionDate.getFullYear(),
          extensionDate.getMonth(),
          extensionDate.getDate(),
          23,
          59,
          59
        )); // Within the extension period

  if (profile?.roles?.includes("reviewer")) {
    return (
      <Navigate to="/submission-dashboard" state={{ from: location }} replace />
    );
  }

  // Redirect if the application is not open
  if (!isApplicationOpen) {
    return (
      <Navigate to="/application-not-open" state={{ from: location }} replace />
    );
  }
  // If user is logged in, render the protected route
  return <Outlet />;
};

export default ProtectedRoute;
